// URLS
import { getV2SCSSUrl } from "../../urls/map-view/SecURL";

// Constants and utils
import { sendGetRequest } from "../../utils/api/apiUtils";
import {
  CitiesBBox,
  CitiesRestaurantsData,
} from "../../constants/CitiesRestaurantsData";

export async function getSecInfo(cityBBox) {
  // checking to hardcoded data or not
  const isShowCityHardCodedData = Object.values(CitiesBBox).includes(cityBBox);

  // if matches return hardcoded data
  if (isShowCityHardCodedData) {
    const response = CitiesRestaurantsData[cityBBox];

    // 5 sec delay
    await new Promise((resolve) => setTimeout(resolve, 5000));

    // response return
    return response;
  }

  // call the api
  const bbox = cityBBox.split(",");
  const params = {
    nw: bbox[1].concat(",", bbox[0]),
    se: bbox[3].concat(",", bbox[2]),
  };
  return sendGetRequest(getV2SCSSUrl, params);
}
